'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'house-chimney';
var width = 576;
var height = 512;
var aliases = [63499,"home-lg"];
var unicode = 'e3af';
var svgPathData = 'M304.4 6.1l-16-14.4-16 14.4-232 208-17.9 16 32 35.7c13.6-12.2 22.2-19.9 25.8-23.2l0 269.3 416 0 0-269.3c3.7 3.3 12.3 11 25.8 23.2l32-35.7c-8.2-7.4-27.5-24.7-57.9-51.9l0-114.2-48 0 0 71.2-144-129.1zm144 193.6l0 264.3-64 0 0-176.5-192 0 0 176.5-64 0 0-264.3 160-143.5 160 143.4zM240.4 464l0-128.5 96 0 0 128.5-96 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHouseChimney = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;